import { ContragentResponse } from '@synapex/shared2/gateway-rest-api'
import cl from 'clsx'
import { ComponentPropsWithoutRef, forwardRef } from 'react'
import classes from './ContragentSelector.module.scss'

export type ContragentBadgeProps = {
    error?: boolean
    value: ContragentResponse | null
} & ComponentPropsWithoutRef<'div'>

export const ContragentBadge = forwardRef<HTMLDivElement, ContragentBadgeProps>(
    ({ value, className, error = false, ...props }, ref) => {
        return (
            <div
                {...props}
                ref={ref}
                className={cl(
                    classes.badge,
                    {
                        [classes.placeholder]: !value,
                        [classes.error]: error,
                    },
                    className
                )}
            >
                <div className={'truncate'}>
                    {value ? value.name : 'Выберите контрагента...'}
                </div>

                <svg
                    className={'shrink-0'}
                    xmlns="http://www.w3.org/2000/svg"
                    width="8"
                    height="6"
                    viewBox="0 0 8 6"
                    fill="none"
                >
                    <path
                        d="M7 1.5L4 4.5L1 1.5"
                        stroke="#94A6AF"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </div>
        )
    }
)
